export default class ChangingThemes {
    constructor(elm, args) {
        var defaultTheme = elm.dataset.defaultTheme;
        var lgTheme = elm.dataset.lgTheme;
        window.addEventListener('resize', updateTheme)
        updateTheme();
        function updateTheme() {
            if (window.innerWidth < 992) {
                elm.classList.remove(lgTheme)
                elm.classList.add(defaultTheme)
            } else {
                elm.classList.remove(defaultTheme)
                elm.classList.add(lgTheme)
            }
        }
    }
}
